<template>
  <div>
    <Base--InlineTextBlock>
      Количество игроков online: {{ countPlayers }}
    </Base--InlineTextBlock>
    <Base--InlineTextBlock>
      Общий итог игры: {{ result }} монет
    </Base--InlineTextBlock>
    <br>
    <v-flex shrink class="row">
      <Base--InlineTextBlock>Установленный интервал между раундами</Base--InlineTextBlock>
      <div>
        <v-text-field
          v-model="delay"
          class="delay-input"
          mask="#####"
        />
      </div>
      <Base--InlineTextBlock style="margin-left: 10px">мс</Base--InlineTextBlock>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: {
    countPlayers: 0,
    result: 0
  },
  computed: {
    delay: {
      get () {
        return this.$store.getters.delay
      },
      set (value) {
        this.$store.commit('SET_DELAY', value)
      }
    }
  }
}
</script>

<style scoped>
    .row {
        display: flex;
        padding-top: 10px;
    }

    .row .title {
        padding-top: 8px;
    }

    .delay-input {
        margin: 0;
        padding: 0;
        width: 50px !important;
    }
</style>
